<template>
  <div>
    <el-collapse v-model="activeNames">
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '1')"
        title="登录状态"
        name="1"
      >
        <div class="verticallyCenter">
          <div class="fs14 mr8">状态</div>
          <el-select v-model="loginStatus" class="mr8 percent58 height32" ref="">
            <el-option
              v-for="(item, index) in loginStatusList"
              :key="index"
              :selected="loginStatus == item.value"
              :value="item.value"
              :label="item.title"
              >{{ item.title }}
            </el-option>
          </el-select>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
        title="登录方式"
        name="2"
      >
        <el-radio-group v-model="loginWay" class="mb16">
          <el-radio label="1" class="mr24">默认登录</el-radio>
          <!-- 暂时不支持第三方登录 后面再改 -->
          <el-radio label="2">第三方登录</el-radio>
        </el-radio-group>
        <div class="content-item" v-if="loginWay == '1'">
          <cx-check-box :value.sync="phoneLogin">手机号登录</cx-check-box>
          <div class="mt12"><cx-check-box :value.sync="codeLogin">扫码登录</cx-check-box></div>
          <div class="mt12"><cx-check-box :value.sync="schoolLogin">机构账号登录</cx-check-box></div>
          <div class="mt12"><cx-check-box :value.sync="testLogin">短信验证码登录</cx-check-box></div>
          <div v-if="testLogin" class="mt8 register-box">
            <div class="verticallyCenter">
              <cx-check-box :value.sync="openRegister" :isDisabled="registerDisable">支持注册账号</cx-check-box>
              <i class="tips-btn icon-portal-info2" @click="explainDialogClick(3)"></i>
            </div>
            <div v-if="!registerDisable && openRegister" class="verticallyCenter preview-box mt8">
              <span class="preview">预览</span>
              <cx-slider :value.sync="viewRegister" :options="viewOptions" :height="32" style="flex: 1;" />
            </div>
          </div>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '2')"
        title="登录地址"
        name="8"
        v-if="loginWay == '2'"
      >
        <div>
          <div>登录接口地址</div>
          <el-input class="mt8" v-model="loginUrl" type="text" placeholder="请输入http://或https://开头的地址">
          </el-input>
        </div>
        <div class="mt16">
          <div>退出登录地址</div>
          <el-input class="mt8" v-model="logoutUrl" type="text" placeholder="请输入http://或https://开头的地址">
          </el-input>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '3')"
        title="注册设置"
        name="3"
      >
        <cx-check-box :value.sync="ifShowRegister">显示注册按钮</cx-check-box>
        <div class="mt12">注册地址</div>
        <el-radio-group v-model="registerAddr" class="mt8">
          <el-radio label="default" class="mr24">默认地址</el-radio>
          <el-radio label="other">其他地址</el-radio>
        </el-radio-group>
        <el-input
          v-if="registerAddr == 'other'"
          class="mt12"
          v-model="registerSrc"
          type="text"
          placeholder="请输入http://或https://开头的地址"
        >
        </el-input>
        <div class="mt12">
          <cx-check-box :value.sync="ifNewOpenReg">新页面打开</cx-check-box>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '4')"
        title="登录跳转"
        name="4"
      >
        <el-radio-group v-model="loginJump">
          <el-radio label="1" class="mr24">个人空间</el-radio>
          <el-radio label="3">其他地址</el-radio>
        </el-radio-group>
        <el-input
          v-if="loginJump == '3' "
          class="mt12"
          v-model="loginSrc"
          type="text"
          placeholder="请输入http://或https://开头的地址"
        >
        </el-input>
<!--        <div class="mt12" v-if="loginJump == '3'">-->
        <div class="mt12">
          <cx-check-box :value.sync="goHistoryRefer">优先跳转来源网站</cx-check-box>
        </div>
        <div class="mt12">
          <cx-check-box :value.sync="ifNewOpenLog">新页面打开</cx-check-box>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '5')"
        title="登录权限"
        name="5"
      >
        <el-radio-group v-model="loginPermission">
          <el-radio label="0">允许全网用户登录</el-radio>
          <el-radio label="1">只允许当前单位用户登录</el-radio>
          <el-radio label="2">允许以下单位用户登录</el-radio>
        </el-radio-group>
        <div class="table-top mt16 verticallyCenter" v-if="loginPermission == '2'">
          <div class="button" @click="addClick()">添加</div>
          <span class="line"></span>
          <div class="button" @click="importClick()">导入</div>
          <span class="line"></span>
          <div class="button" @click="batchDelete()">删除</div>
          <div class="search-box">
            <el-input class="width120" v-model="unionName" placeholder="搜索"></el-input>
            <i class="icon-portal-search1" @click="loadOrgUnions()"></i>
          </div>
        </div>
        <div class="table-box" v-if="loginPermission == '2'">
          <el-table :data="unitTableData" border @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="28"> </el-table-column>
            <el-table-column prop="fid" label="单位fid" width="64"> </el-table-column>
            <el-table-column prop="orgName" label="单位名称" width="116"> </el-table-column>
            <el-table-column label="操作" width="44">
              <template v-slot="scope">
                <i class="del-btn icon-portal-delete1" @click="deleteClick(scope)"></i>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            :page-size="pageSize"
            layout="prev, pager, next"
            :total="total"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '6')"
        title="登录失效设置"
        name="6"
      >
        <el-radio-group v-model="loseTime" class="lose-radio">
          <el-radio label="1">30天</el-radio>
          <el-radio label="2">7天</el-radio>
          <el-radio label="3">1天</el-radio>
          <el-radio label="4">30分钟</el-radio>
          <el-radio label="5">
            自定义<el-input class="width80" v-model="customTime" placeholder="请输入"></el-input>小时
          </el-radio>
        </el-radio-group>
      </el-collapse-item>
      <el-collapse-item
        @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')"
        title="高级设置"
        name="7"
      >
        <div class="verticallyCenter">
          <cx-check-box :value.sync="showImageCode">登录验证码</cx-check-box>
          <i class="tips-btn icon-portal-info2"></i>
        </div>
        <div class="verticallyCenter mt8">
          <cx-check-box :value.sync="showMessageSign">短信签名</cx-check-box>
          <i class="tips-btn icon-portal-info2" @click="explainDialogClick(1)"></i>
        </div>
        <el-input
          v-if="showMessageSign"
          class="mt8"
          v-model="signText"
          type="text"
          placeholder="请输入"
        >
        </el-input>
        <div class="verticallyCenter mt8">
          <cx-check-box :value.sync="jumpImproveInfo">跳过完善信息步骤</cx-check-box>
          <i class="tips-btn icon-portal-info2" @click="explainDialogClick(2)"></i>
        </div>
      </el-collapse-item>
      <!-- <el-collapse-item @mousedown.native="collapseMouseDown(collapseActiveNames, $event, '7')" title="高级设置" name="7">
        <cx-check-box :value.sync="doubleFactor">启用双因素登录</cx-check-box>
        <div class="mt16">
          <cx-check-box :value.sync="alonePassword">启用独立密码</cx-check-box>
        </div>
      </el-collapse-item> -->
    </el-collapse>
    <el-dialog title="添加" :visible.sync="visibleAdd" :append-to-body="true" custom-class="addDataDialog">
      <div class="verticallyCenter">
        <label>单位fid</label>
        <el-input placeholder="单位fid" v-model="unitFid" type="number"></el-input>
      </div>
      <div class="verticallyCenter">
        <label>单位名</label>
        <el-input placeholder="单位名" v-model="unitName"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleAdd = false">取 消</el-button>
        <el-button type="primary" @click="addOrgUnion()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="导入" :visible.sync="visibleReport" :append-to-body="true" custom-class="reportDataDialog">
      <div class="download-box">
        <span>请下载模版，按格式修改后导入</span>
        <a href="javascript:" class="btns" @click="downloadTemplate()"><i class="icon"></i><span>下载模板</span></a>
      </div>
      <el-upload
        class="upload-xlsx"
        drag
        :action="importUrl"
        accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        :show-file-list="false"
        :on-error="handleError"
        :on-progress="handleProgress"
        :on-success="handleSuccess"
      >
        <img :src="uploadImg" alt="" class="icon" />
        <div class="el-upload__text" v-if="!excelName">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__text" v-else>{{ excelName }}<em>重新上传</em></div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleReport = false">取 消</el-button>
        <el-button type="primary" @click="importOrgUnion()">导入</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="说明"
      :append-to-body="true"
      :visible.sync="explainDialog"
      custom-class="explainDialog"
    >
      <p class="fs14 tips">
        {{ explainTitle }}
      </p>
      <p class="fs14 tips subTitle" v-if="explainSubTitle">{{ explainSubTitle }}</p>
      <p class="fs14 tips" v-if="explainTips1">{{ explainTips1 }}</p>
      <p class="fs14 tips" v-if="explainTips2">{{ explainTips2 }}</p>
    </el-dialog>
  </div>
</template>

<script>
import Qs from "qs"
import $ from "jquery"
import { handleFindLayoutComponentOptions, getAllColsUidInLayoutComponent, simpleDeepClone } from "utils"
import uploadImgGrey from "../../../../../assets/images/login/excel_grey.png"
import uploadImg from "../../../../../assets/images/login/excel.png"
import { image_children } from "materials/image/menus/index.js"
import { input_children } from "materials/input/menus/index.js"
import { home, appHome } from "dependencies/login/diffrence_options"
export default {
  components: {},
  props: {
    options: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      activeNames: ["1", "2", "3"],
      collapseActiveNames: ["1", "2", "3"],
      multipleSelection: [],
      unitTableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 0,
      unionName: "", //单位名称，模糊查询条件
      visibleAdd: false,
      unitFid: "",
      unitName: "",
      visibleReport: false,
      uploadImg: uploadImgGrey,
      excelName: "",
      importUrl: "",
      loginInterval: "",
      explainDialog: false,
      explainTitle: "",
      explainSubTitle: "",
      explainTips1: "",
      explainTips2: "",
      viewOptions: [
        { value: true, title: "", iconClass: "icon-portal-preview-open1" },
        { value: false, title: "", iconClass: "icon-portal-preview-close-one1" }
      ],
      registerDisable: false
    }
  },
  beforeMount() {
    this.uid1 = this.colsUid()
    this.uid2 = this.colsUid(2)
    this.uid3 = this.colsUid(3)
    this.elementInLayout = handleFindLayoutComponentOptions([this.getOptions.rows[0]], this.uid1)
    this.elementInLayout2 = handleFindLayoutComponentOptions([this.getOptions.rows[2]], this.uid2)
    this.elementInLayout3 = handleFindLayoutComponentOptions([this.getOptions.rows[3]], this.uid3)
    this.registIdx1 = this.findElementIndex(this.elementInLayout, "loginRegister")
    this.registIdx2 = this.findElementIndex(this.elementInLayout2, "loginRegister")
    this.registIdx3 = this.findElementIndex(this.elementInLayout3, "loginRegister")
    if (this.getOptions.rows.length < 7) {
      if (this.request_prefix === "stage") {
        this.getOptions.rows.push(simpleDeepClone(home[0].rows[6]))
      } else {
        this.getOptions.rows.push(simpleDeepClone(appHome[0].rows[6]))
      }
    }
  },
  mounted() {
    this.importUrl = `/website-org-union/${this.$store.state.states.getDataPageIds.websiteId}/import`
  },
  computed: {
    ids() {
      return this.$store.state.states.activeID
    },
    getOptions: function () {
      return this.$getOptions(this.ids)
    },
    loginStatus: {
      get() {
        let status = this.checkAndSetPrimaryVal(this.getOptions, "loginStatus", "loginStatus", "1")
        this.tipsIdx1 = this.findElementIndex(this.elementInLayout, "loginError")
        this.tipsIdx2 = this.findElementIndex(this.elementInLayout2, "loginError")
        this.tipsIdx3 = this.findElementIndex(this.elementInLayout3, "loginError")
        if (status == "1") {
          this.changeOptionsEV(0, "opacity", this.uid1, this.elementInLayout, this.tipsIdx1, 0)
          this.changeOptionsEV(0, "opacity", this.uid2, this.elementInLayout2, this.tipsIdx2, 2)
          this.changeOptionsEV(0, "opacity", this.uid3, this.elementInLayout3, this.tipsIdx3, 3)
        } else if (status == "2") {
          this.changeOptionsEV(100, "opacity", this.uid1, this.elementInLayout, this.tipsIdx1, 0)
          this.changeOptionsEV(100, "opacity", this.uid2, this.elementInLayout2, this.tipsIdx2, 2)
          this.changeOptionsEV(100, "opacity", this.uid3, this.elementInLayout3, this.tipsIdx3, 3)
        }
        return status
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loginStatus", false)
      }
    },
    loginStatusList: {
      get() {
        let list = [
          {
            title: "默认",
            value: "1"
          },
          {
            title: "错误",
            value: "2"
          }
        ]
        if (this.doubleFactor) {
          list.push({
            title: "双因素安全验证",
            value: "3"
          })
        }
        if (this.alonePassword) {
          list.push(
            {
              title: "设置独立密码",
              value: "4"
            },
            {
              title: "独立密码验证",
              value: "5"
            }
          )
        }
        return this.checkAndSetPrimaryVal(this.getOptions, "loginStatusList", "loginStatusList", list)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loginStatusList", false)
      }
    },
    loginWay: {
      get() {
        let way = this.getOptions.loginWay || "1"
        return way
      },
      set(newVal) {
        let placeholder = "手机号"
        let titleOptions = this.getOptions.titleOptions
        let tabRect = this.getOptions.titleOptions[0].elementOptions[0] // 写死原因是 tab永远放在top 的第一个
        if (newVal == "2") {
          placeholder = "账号"
          tabRect.options.activeIndex = 0
          tabRect.isShow = false
          this.phoneLogin = true
          this.$changeOptionsEV(0, "activeIndex", false)
        } else {
          tabRect.isShow = true
        }
        titleOptions[0].elementOptions[0] = tabRect
        this.$changeOptionsEV(titleOptions, "titleOptions", false, false, false, true)
        $(
          `.container_id_${this.ids.container_id}-rect_id_${this.ids.rect_id}-uid_${this.uid1}-elementInLayoutId_${this.elementInLayout[0].elementInLayoutId} .input-component input`
        ).attr("placeholder", placeholder)
        this.changeOptionsEV(placeholder, "placeholder", this.uid1, this.elementInLayout, this.tipsIdx1, 0)
        this.$changeOptionsEV(newVal, "loginWay", false)
      }
    },
    checkBoxList() {
      let arr = [this.phoneLogin, this.codeLogin, this.schoolLogin, this.testLogin]
      // let count = arr.filter(item => item == true)
      return arr
    },
    phoneLogin: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "phoneLogin", "phoneLogin", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "phoneLogin", false)
        this.setLoginWays(1, newVal)
        this.setActiveIndex()
      }
    },
    codeLogin: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "codeLogin", "codeLogin", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "codeLogin", false)
        this.setLoginWays(2, newVal)
        this.setActiveIndex()
      }
    },
    schoolLogin: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "schoolLogin", "schoolLogin", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "schoolLogin", false)
        this.setLoginWays(3, newVal)
        this.setActiveIndex()
      }
    },
    testLogin: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "testLogin", "testLogin", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "testLogin", false)
        this.setLoginWays(4, newVal)
        this.setActiveIndex()
      }
    },
    openRegister: {
      get() {
        this.checkAndSetPrimaryVal(this.getOptions, "openRegister", "openRegister", false)
        return this.getOptions.openRegister
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "openRegister", false)
      }
    },
    viewRegister: {
      get() {
        this.checkAndSetPrimaryVal(this.getOptions, "viewRegister", "viewRegister", false)
        return this.getOptions.viewRegister
      },
      set(newVal) {
        this.$changeOptionsEV(newVal ? 6 : 3, "activeIndex", false)
        this.$changeOptionsEV(newVal, "viewRegister", false)
      }
    },
    ifShowRegister: {
      get() {
        let ifShowRegister = this.checkAndSetPrimaryVal(this.getOptions, "ifShowRegister", "ifShowRegister", true)
        let registText = ""
        if (ifShowRegister) {
          registText = "新用户注册"
        }
        this.changeOptionsEV(registText, "content", this.uid1, this.elementInLayout, this.registIdx1, 0)
        this.changeOptionsEV(registText, "content", this.uid2, this.elementInLayout2, this.registIdx2, 2)
        this.changeOptionsEV(registText, "content", this.uid3, this.elementInLayout3, this.registIdx3, 3)
        return this.checkAndSetPrimaryVal(this.getOptions, "ifShowRegister", "ifShowRegister", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ifShowRegister", false)
        let registText = ""
        if (newVal) {
          registText = "新用户注册"
        }
        this.changeOptionsEV(registText, "content", this.uid1, this.elementInLayout, this.registIdx1, 0)
        this.changeOptionsEV(registText, "content", this.uid2, this.elementInLayout2, this.registIdx2, 2)
        this.changeOptionsEV(registText, "content", this.uid3, this.elementInLayout3, this.registIdx3, 3)
      }
    },
    registerAddr: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "registerAddr", "registerAddr", "default")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "registerAddr", false)
      }
    },
    ifNewOpenReg: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "ifNewOpenReg", "ifNewOpenReg", true)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ifNewOpenReg", false)
        this.$changeOptionsEV(newVal, "openBlankPage", false, null, {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: this.uid1,
          elementInLayoutId: this.elementInLayout[6].elementInLayoutId
        })
      }
    },
    goHistoryRefer: {
      get() {
        return this.getOptions.hasOwnProperty("goHistoryRefer") ? this.getOptions.goHistoryRefer : true
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "goHistoryRefer", false)
      }
    },
    registerSrc: {
      get() {
        return this.getOptions.registerSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "registerSrc", false)
      }
    },
    loginJump: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "loginJump", "loginJump", "1")
      },
      set(newVal) {
        // if(newVal == '1'){
        //   // 跳转到个人空间后，清空优先跳转来源网站
        //   this.goHistoryRefer = false
        // }else if(newVal == '3'){
        //   this.goHistoryRefer = true
        // }
        this.$changeOptionsEV(newVal, "loginJump", false)
      }
    },
    ifNewOpenLog: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "ifNewOpenLog", "ifNewOpenLog", false)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "ifNewOpenLog", false)
        this.$changeOptionsEV(newVal, "openBlankPage", false, null, {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: this.uid1,
          elementInLayoutId: this.elementInLayout[5].elementInLayoutId
        })
      }
    },
    loginSrc: {
      get() {
        return this.getOptions.loginSrc || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loginSrc", false)
      }
    },
    loginPermission: {
      get() {
        if (this.checkAndSetPrimaryVal(this.getOptions, "loginPermission", "loginPermission", "0") == "2") {
          this.loadOrgUnions()
        }
        return this.checkAndSetPrimaryVal(this.getOptions, "loginPermission", "loginPermission", "0")
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loginPermission", false)
      }
    },
    loseTime: {
      get() {
        let loseTime = this.checkAndSetPrimaryVal(this.getOptions, "loseTime", "loseTime", "5")
        if (loseTime == 1) {
          this.loginInterval = 30 * 24 * 60 * 60
        } else if (loseTime == 2) {
          this.loginInterval = 7 * 24 * 60 * 60
        } else if (loseTime == 3) {
          this.loginInterval = 1 * 24 * 60 * 60
        } else if (loseTime == 4) {
          this.loginInterval = 30 * 60
        } else if (loseTime == 5) {
          this.loginInterval = this.customTime * 60 * 60
        }
        this.loginFactor()
        return loseTime
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loseTime", false)
      }
    },
    customTime: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "customTime", "customTime", 12)
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "customTime", false)
      }
    },
    doubleFactor: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "doubleFactor", "doubleFactor", "false")
      },
      set(newVal) {
        let newList = this.loginStatusList
        if (newVal) {
          newList.push({
            title: "双因素安全验证",
            value: "3"
          })
        } else {
          newList.splice(
            newList.findIndex(item => item.value === "3"),
            1
          )
        }
        this.loginStatusList = newList
        this.$changeOptionsEV(newVal, "doubleFactor", false)
      }
    },
    alonePassword: {
      get() {
        return this.checkAndSetPrimaryVal(this.getOptions, "alonePassword", "alonePassword", "false")
      },
      set(newVal) {
        let newList = this.loginStatusList
        if (newVal) {
          newList.push(
            {
              title: "设置独立密码",
              value: "4"
            },
            {
              title: "独立密码验证",
              value: "5"
            }
          )
        } else {
          newList.splice(
            newList.findIndex(item => item.value === "4"),
            1
          )
          newList.splice(
            newList.findIndex(item => item.value === "5"),
            1
          )
        }
        this.$changeOptionsEV(newVal, "alonePassword", false)
      }
    },
    loginUrl: {
      get() {
        return this.getOptions.loginUrl || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "loginUrl", false)
      }
    },
    logoutUrl: {
      get() {
        return this.getOptions.logoutUrl || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "logoutUrl", false)
      }
    },
    showMessageSign: {
      get() {
        return this.getOptions?.showMessageSign || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showMessageSign", false)
      }
    },
    jumpImproveInfo: {
      get() {
        return this.getOptions?.jumpImproveInfo || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "jumpImproveInfo", false)
      }
    },
    signText: {
      get() {
        return this.getOptions?.signText || ""
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "signText", false)
      }
    },
    showImageCode: {
      get() {
        return this.getOptions?.showImageCode || false
      },
      set(newVal) {
        this.$changeOptionsEV(newVal, "showImageCode", false)
        this.setImageComponent(newVal)
      }
    },
    tabsList() {
      const elementOptions = this.getOptions.titleOptions[0].elementOptions[0] // 写死原因是 tab永远放在top 的第一个
      const tabsList = elementOptions.options.tabsList
      return tabsList
    }
  },
  methods: {
    setImageComponent(show) {
      this.tabsList.forEach((item, index) => {
        if (item.name === "手机号登录" || item.name === "机构账号登录") {
          const getElement = this.getElementInLayout(index)
          const inputElement = this.findElementIds(getElement, "loginCodeInput")?.element
          const imageElement = this.findElementIds(getElement, "loginCodeImage")?.element
          if (!inputElement && show) {
            const input = input_children[0]
            let options = JSON.parse(JSON.stringify(input.attribute.options))
            options.loginType = "loginCodeInput"
            options.width = 360
            options.height = 48
            options.placeholder = "请输入验证码"
            options.readonly = true
            options.borderWidth = 1
            options.borderColor = "#ECECF1"
            options.textPaddingTypeFlag = 2
            options.paddingLeft = 12
            let param = {
              ...this.ids,
              uid: getElement.loginUid,
              elementOptions: options,
              activeIndex: index
            }
            this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
          } else {
            this.setOptions(getElement, "loginCodeInput", "isShow", show)
          }
          if (!imageElement && show) {
            const input = image_children[0]
            let options = JSON.parse(JSON.stringify(input.attribute.options))
            options.loginType = "loginCodeImage"
            options.width = 66
            options.height = 33
            options.left = 296
            options.top = 16
            options.shapeType = "radius"
            options.clipSize = "100% 100%"
            options.imgSrc = "https://p.cldisk.com/star3/origin/ead2350633297ac5ca7b80168694f1ab.jpeg?rw=200&rh=42&_fileSize=3975&_orientation=1"
            
            let param = {
              ...this.ids,
              uid: getElement.loginUid,
              elementOptions: options,
              activeIndex: index
            }
            this.$store.dispatch(this.request_prefix + "/addComponentInLayout", param)
          } else {
            this.setOptions(getElement, "loginCodeImage", "isShow", show)
          }
        }
      })
    },
    findElementIds(currentElement, type) {
      const element = currentElement.loginElementInLayout
      let elementInLayoutId = null
      let component = null
      if (element) {
        component = element.find(item => item.loginType === type)
        if (!component) {
          const autoLayout = element.find(item => item.innerElement === "cxAutoLayout")
          if (autoLayout && autoLayout.elementOptions) {
            component = autoLayout.elementOptions.find(item => item.loginType === type)
            elementInLayoutId = component ? autoLayout?.elementInLayoutId : null
          }
        } else {
          elementInLayoutId = component?.elementInLayoutId
        }
      }
      if (elementInLayoutId !== null) {
        return {
          ids: {
            ...currentElement.loginMsg,
            uid: currentElement.loginUid,
            elementInLayoutId: elementInLayoutId,
            elementInAutoLayoutId: component?.elementInAutoLayoutId
          },
          element: component
        }
      } else return null
    },
    // 获取单元格的信息
    getElementInLayout(index) {
      const loginMsg = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        elementInAutoLayoutId: this.ids.elementInAutoLayoutId,
        path: this.ids.path
      }
      const loginOptions = [this.getOptions.rows[index]]
      const loginUid = getAllColsUidInLayoutComponent(loginOptions)[0]
      const loginElementInLayout = handleFindLayoutComponentOptions(loginOptions, loginUid)
      return {
        loginOptions: this.getOptions,
        loginMsg: loginMsg,
        loginUid: loginUid,
        loginElementInLayout: loginElementInLayout
      }
    },
    setOptions(getElement, type, name, value) {
      const ids = this.findElementIds(getElement, type)?.ids
      if (!ids) return
      if (name === "isShow") {
        const element = getElement.loginElementInLayout.find(item => {
          return item.loginType === type
        })
        if (element && element.opacity === 0) {
          this.$changeOptionsEV(100, "opacity", false, null, ids)
        }
      }
      this.$changeOptionsEV(value, name, false, null, ids)
    },
    setActiveIndex() {
      let titleOptions = this.getOptions.titleOptions
      let tabRect = this.getOptions.titleOptions[0].elementOptions[0] // 写死原因是 tab永远放在top 的第一个
      let firstIndex = tabRect.options.tabsList?.findIndex(item => !item.isHide)
      tabRect.options.activeIndex = firstIndex
      titleOptions[0].elementOptions[0] = tabRect
      this.$changeOptionsEV(firstIndex, "activeIndex", false, false, false, true)
      this.$changeOptionsEV(titleOptions, "titleOptions", false, false, false, true)
    },
    findElementIndex(element, type) {
      return element ? element.findIndex(item => item.loginType === type) : -1
    },
    changeOptionsEV(value, name, uid, elementInLayout, index, activeIndex) {
      if (index !== -1) {
        const _ids = {
          container_id: this.ids.container_id,
          rect_id: this.ids.rect_id,
          uid: uid,
          elementInLayoutId: elementInLayout[index].elementInLayoutId
        }
        if (this.ids.hasOwnProperty("elementInAutoLayoutId")) {
          _ids.elementInAutoLayoutId = this.ids.elementInAutoLayoutId
          _ids.activeIndex = activeIndex
        }
        this.$changeOptionsEV(value, name, false, null, _ids, true)
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    setLoginWays(type, value) {
      let directionIndex = 0 // 写死第一个原因是 tab永远放在top
      let tabRect = this.getOptions.titleOptions[0].elementOptions // 写死第一个原因是 tab永远放在top
      tabRect = tabRect.find(options => options.innerElement === "cxTabs")
      if (!tabRect) {
        return
      }
      let tabOptions = tabRect.options
      let tabsList = tabOptions.tabsList
      let elementInLayoutId = tabRect.elementInLayoutId
      for (let i = 0; i < tabsList.length; i++) {
        if (type === tabsList[i].loginWay) {
          tabsList[i].isHide = !value
          break
        }
      }
      let count = tabsList.filter(item => item.isHide == false).length
      let tabIsHide = count > 1 ? false : true
      const _ids = {
        container_id: this.ids.container_id,
        rect_id: this.ids.rect_id,
        directionIndex: directionIndex,
        elementInLayoutId: elementInLayoutId
      }
      if (this.ids.hasOwnProperty("elementInAutoLayoutId")) {
        _ids.elementInAutoLayoutId = this.ids.elementInAutoLayoutId
      }
      this.$changeOptionsEV(tabIsHide, "isHide", false, undefined, _ids, true)
      this.$changeOptionsEV(tabsList, "tabsList", false, undefined, _ids, true)
    },
    colsUid(item) {
      let index = item || 0
      const layoutRowsArr = this.getOptions.rows[index]
      const colsUid = getAllColsUidInLayoutComponent([layoutRowsArr])[0] //获取当前row里的所有cols的uid
      return colsUid
    },
    loadOrgUnions() {
      const that = this
      let params = {
        websiteId: this.$store.state.states.getDataPageIds.websiteId,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        unionName: this.unionName
      }
      this.$changeOptionsEV(params.websiteId, "websiteId", false)
      this.instance({
        method: "post",
        url: `website-org-union/get`,
        params: params
      })
        .then(res => {
          if (res.data.code === 1) {
            that.unitTableData = res.data.data.list
            that.total = res.data.data.total
          }
        })
        .catch(err => {})
    },
    addClick() {
      this.visibleAdd = true
      this.unitFid = ""
      this.unitName = ""
    },
    addOrgUnion() {
      if (!this.unitFid) {
        this.$message({
          message: "单位fid不能为空",
          type: "warning"
        })
      } else if (!this.unitName) {
        this.$message({
          message: "单位名不能为空",
          type: "warning"
        })
      } else {
        this.visibleAdd = false
        let params = {
          websiteId: this.$store.state.states.getDataPageIds.websiteId,
          fid: this.unitFid,
          orgName: this.unitName
        }
        this.instance({
          method: "post",
          url: `website-org-union/add`,
          params: params
        })
          .then(res => {
            if (res.data.code === 1) {
              this.$message({
                message: "添加成功！",
                type: "success"
              })
              this.loadOrgUnions()
            } else {
              this.$message({
                message: res.data.message,
                type: "warning"
              })
            }
          })
          .catch(err => {})
      }
    },
    batchDelete() {
      let that = this
      if (this.multipleSelection.length > 0) {
        $.post("/website-org-union/batch-delete", { dataJson: JSON.stringify(this.multipleSelection) }, function (res) {
          if (res.code == 1) {
            that.$message({
              message: "删除成功！",
              type: "success"
            })
            that.loadOrgUnions()
          } else {
            that.$message({
              message: res.message,
              type: "warning"
            })
          }
        })
      } else {
        this.$message({
          message: "请选择需要删除的数据",
          type: "warning"
        })
      }
    },
    deleteClick(item) {
      this.instance({
        method: "post",
        url: `website-org-union/delete`,
        params: item.row
      })
        .then(res => {
          if (res.data.code === 1) {
            this.$message({
              message: "删除成功！",
              type: "success"
            })
            this.loadOrgUnions()
          } else {
            this.$message({
              message: res.data.message,
              type: "warning"
            })
          }
        })
        .catch(err => {})
    },
    handleCurrentChange(curPage) {
      // 选中页码发生改变
      this.pageNum = curPage
      this.loadOrgUnions()
    },
    importClick() {
      this.visibleReport = true
    },
    //上传中
    handleProgress() {
      // console.log("上传中")
    },
    //上传失败
    handleError() {
      // console.log("上传失败")
    },
    //上传成功
    handleSuccess(response, file) {
      // console.log("上传成功",response, file)
      this.excelName = file.name
      this.uploadImg = uploadImg
    },
    downloadTemplate() {
      var url = "/website-org-union/export-tmp"
      window.open(url)
    },
    importOrgUnion() {
      this.visibleReport = false
      if (this.excelName) {
        this.loadOrgUnions()
        this.$message({
          message: "导入成功！",
          type: "success"
        })
      } else {
        this.$message({
          message: "导入失败！",
          type: "warning"
        })
      }
    },
    //提交登录条件
    loginFactor() {
      let data = {
        websiteId: this.$store.state.states.getDataPageIds.websiteId,
        name: "",
        domain: document.domain.substring(0, document.domain.length - 16),
        domainExternal: "",
        loginMethod: 1,
        icon: "",
        loginMethodUrl: "10000", //默认值
        loginUrl: "", //第三方登录地址
        logoutUrl: "",
        registUrl: "",
        loginCurrentOrg: this.loginPermission, // 登录权限
        loginInterval: this.loginInterval, // 登录失效时间
        charge: "0",
        customGotoUrl: "",
        loginAutoRefer: "",
        key: "",
        isV2EditPage: true
      }
      this.instance({
        method: "post",
        url: `advanced/setting/update?loginJumpType=${this.loginJump}`,
        params: data
      })
        .then(res => {
          // console.log('res.data :>>',res.data);
        })
        .catch(err => {})
    },
    explainDialogClick(type) {
      this.explainDialog = true
      switch (type) {
        case 1:
          this.explainTitle = "短信签名用于显示短信验证码前缀名称，需要提前开通才能正常发送，例如："
          this.explainSubTitle = ""
          this.explainTips1 = "【智慧门户引擎】您的验证码为：123456，有效期为5分钟"
          this.explainTips2 = "其中括号内的“智慧门户引擎”为签名。"
          break
        case 2:
          this.explainTitle = "勾选后，用户点击登录不会跳转到弱密码提示、绑定手机号等的提示流程"
          this.explainSubTitle = ""
          this.explainTips1 = ""
          this.explainTips2 = ""
          break
        case 3:
          this.explainTitle = "当单位下没有该用户时会自动注册到单位下"
          this.explainSubTitle = "开启条件"
          this.explainTips1 = "需要提前开通当前单位的“开放注册”属性"
          this.explainTips2 = ""
          break
        default:
      }
    },
  }
}
</script>

<style scoped lang="scss">
.width80 {
  width: 80px;
  margin: 0 8px;
}
.width120 {
  width: 120px;
}
.lose-radio .el-radio {
  margin-right: 9px;
  margin-top: 6px;
  margin-bottom: 6px;
}
.mr24 {
  margin-right: 24px !important;
}

.table-top {
  .button {
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    color: var(--themeColor);
  }
  .line {
    display: inline-block;
    margin: 4px 6px;
    background: rgba(0, 0, 0, 0.07);
    width: 1px;
    height: 12px;
  }
  .search-box {
    position: relative;
    margin-left: auto;
    i {
      position: absolute;
      font-size: 16px;
      right: 9px;
      top: 50%;
      transform: translateY(-50%);
      color: var(--thirdTextColor);
      cursor: pointer;
    }
  }
}
.table-box {
  margin-top: 8px;
  ::v-deep .el-table {
    font-size: 12px;
    .cell {
      line-height: 17px;
      padding-left: 8px;
      padding-right: 8px;
    }
    th {
      padding: 4.5px 0;
      background-color: #f5f8fb;
      color: var(--thirdTextColor);
    }
    td {
      padding: 4.5px 0;
      color: var(--textColor);
      .cell {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    .el-table-column--selection {
      .cell {
        padding-right: 0;
        padding-left: 6px;
      }
    }
    .del-btn {
      font-size: 16px;
      color: var(--thirdTextColor);
      cursor: pointer;
      margin-left: 5px;
    }
  }
  ::v-deep .el-pagination {
    padding: 0;
    margin-top: 8px;
    text-align: center;
    .el-pager {
      li {
        height: 22px;
        line-height: 22px;
        min-width: 22px;
        padding: 0;
      }
    }
    button {
      height: 22px;
      line-height: 22px;
      min-width: 22px;
      padding: 0;
    }
  }
}
::v-deep .addDataDialog {
  width: 352px;
  height: 262px;
  border-radius: 8px;
  margin-top: 30vh !important;
  .el-dialog__body {
    padding: 32px;
    label {
      width: 46px;
      margin-right: 16px;
    }
    .verticallyCenter {
      & + .verticallyCenter {
        margin-top: 16px;
      }
    }
    .el-input {
      width: 226px;
    }
  }
  .el-dialog__footer {
    border-radius: 0 0 8px 8px;
    padding: 16px 0;
    .el-button {
      padding: 8px 16px;
      & + .el-button {
        margin-left: 24px;
      }
    }
  }
}
::v-deep .reportDataDialog {
  width: 500px;
  // height: 419px;
  border-radius: 8px;
  margin-top: 30vh !important;
  .el-dialog__body {
    padding: 32px;
    .download-box {
      display: flex;
      justify-content: space-between;
      background: #eaf2ff;
      border-radius: 4px;
      width: 100%;
      height: 37px;
      line-height: 37px;
      font-size: 13px;
      color: var(--thirdTextColor);
      padding: 0 16px;
      .btns {
        display: flex;
        font-size: 14px;
        color: #3d82f2;
        i {
          display: block;
          margin-top: 9px;
          width: 14px;
          height: 14px;
          margin-right: 4px;
          background-image: url(../../../../../assets/images/login/download.png);
          background-size: 100% 100%;
        }
      }
    }
    .upload-xlsx {
      margin-top: 16px;
      .el-upload-dragger {
        width: 436px;
        min-height: 158px;
        border: 1px dashed #e9e9e9;
        background: #fcfcfc;
        border-radius: 4px;
        padding: 48px 0 32px;
        .el-upload__text {
          margin-top: 12px;
        }
      }
    }
  }
  .el-dialog__footer {
    border-radius: 0 0 8px 8px;
    padding: 16px 0;
    .el-button {
      padding: 8px 16px;
      & + .el-button {
        margin-left: 24px;
      }
    }
  }
}
.register-box {
  border: 1px solid rgba(233, 233, 233, 1);
  background: rgba(251, 252, 253, 1);
  border-radius: 4px;
  padding: 12px;
  .preview-box {
    gap: 12px;
    .preview {
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 13px;
      color: rgba(0, 0, 0, 0.8);
    }
  }
}
::v-deep .explainDialog {
  .subTitle {
    font-weight: bold;
    margin-top: 20px;
  }
}
</style>
